import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  styled
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { JobResult, jobResultStyle } from 'components/JobExecution/JobResult';
import moment from 'moment';
import { ExecutionRuntime } from 'components/JobExecution/ExecutionRuntime';
import { StartedBy } from 'components/JobExecution/StartedBy';

const StyledTable = styled(Table)({
  minWidth: 650,
});

const ExecutionList = ({ executions }) => {
  return (
    <StyledTable>
      <TableHead>
        <TableRow>
          <TableCell>Job Name</TableCell>
          <TableCell>Start Time</TableCell>
          <TableCell>Job Type</TableCell>
          <TableCell>Result</TableCell>
          <TableCell>Runtime</TableCell>
          <TableCell>Details</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {executions.map((e) => (
          <TableRow key={e._id} style={jobResultStyle(e.result)}>
            <TableCell>{e.jobName}</TableCell>
            <TableCell>
              {moment(e.startTime).format('HH:mm')}
              <br />
              <StartedBy execution={e} />
            </TableCell>
            <TableCell>{e.jobType}</TableCell>
            <TableCell><JobResult result={e.result} /></TableCell>
            <TableCell><ExecutionRuntime execution={e} /></TableCell>
            <TableCell>
              <IconButton component={RouterLink} to={`/job_executions/${e.uuid}`}>
                <ArrowForwardIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

export default ExecutionList;
